import { Icon, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import {
  EXPORT_TEMPLATE_MAX_LIMIT,
  EXPORT_TEMPLATE_MAX_LIMIT_FOR_INTEGRATION,
} from '../../constant';
import { useTemplateContext } from '../../context';
import { TemplateCategories } from '../template-categories';
import * as Styled from './styles';
import * as SX from './sx';
import type { TemplateColumnsProps as Props } from './types';

export const TemplateColumns = memo(
  ({ className, columns, checkedValues, integrationConfig }: Props) => {
    const { totalSelectedOptions, isLoading } = useTemplateContext();

    const maxLimit = useMemo(
      () =>
        integrationConfig
          ? EXPORT_TEMPLATE_MAX_LIMIT_FOR_INTEGRATION
          : EXPORT_TEMPLATE_MAX_LIMIT,
      [integrationConfig]
    );

    const defaultExpandedCategory = useMemo(
      () => (columns.items.length === 1 ? columns.items[0].name : null),
      [columns.items]
    );

    return (
      <Styled.Wrapper
        className={classnames('TemplateColumns', className)}
        sx={SX.root}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body3" fontWeight={500} color="grey.700">
            Columns Set for Export
          </Typography>

          <Label color="primary" variant="outlined" size="xsmall">
            {columns.categoryWithNoChildren ? (
              totalSelectedOptions
            ) : isLoading ? (
              <Icon name="loading-twotone-loop" size={12} color="primary.500" />
            ) : (
              `${totalSelectedOptions} / ${maxLimit}`
            )}
          </Label>
        </Stack>

        <TemplateCategories
          checkedValues={checkedValues}
          columns={columns}
          defaultExpandedCategory={defaultExpandedCategory}
        />
      </Styled.Wrapper>
    );
  }
);

TemplateColumns.displayName = 'TemplateColumns';
